const styleSheet = new CSSStyleSheet();
const styleSheetContent = `
    section[data-sizing="form-wrapper"] {
        max-width: 600px !important;
    }

    h2, p, button {
        color: rgba(var(--color-foreground)) !important;
    }

    label, div {
        color: rgb(var(--color-foreground-secondary)) !important;
    }

    h2 {
        font-weight: bold !important;
    }

    button {
        font-size: 16px !important;
        font-weight: var(--font-button-weight) !important;
        background-color: #FDC130 !important;
        border-radius: var(--border-radius-button) !important;
    }

    h2 {
        font-size: calc(var(--font-heading-h4-scale) * 2rem) !important;
        line-height: 1 !important;
    }

    section div > p {
        font-size: calc(var(--font-heading-h4-scale) * 2rem) !important;
    }

    input {
        border-radius: var(--border-radius-input) !important;
    }

    input:focus-visible {
        box-shadow: 0 0 0 2px #FDC130 !important;
    }

    input::placeholder {
        color: red !important;
    }

    section[data-testid="banner-success"] div p {
        display: none !important;
    }
`;
styleSheet.replaceSync(styleSheetContent);

const observer = new MutationObserver((mutations, obs) => {
  const shadowHost = document.querySelector('shopify-forms-embed');
  if (shadowHost) {
    console.log('Found shadow host:', shadowHost);
    const shadowRoot = shadowHost?.shadowRoot;
    console.log('SHADOW ROOT: ', shadowRoot);
    //shadowRoot.adoptedStyleSheets = [];
    obs.disconnect();

    const waitForShadow = setInterval(() => {
      if (shadowHost.shadowRoot) {
        clearInterval(waitForShadow);
        console.log('Found shadow root!');
        shadowHost.shadowRoot.adoptedStyleSheets = [
          ...shadowHost.shadowRoot.adoptedStyleSheets,
          styleSheet
        ];
      }
    }, 200);
  }
});

observer.observe(document.body, { childList: true, subtree: true });
